export default __webpack_public_path__ + "static/media/coco-logo.89fb8334.svg";